import { render } from "./layouts.vue?vue&type=template&id=7dbbb0c6"
import script from "./layouts.vue?vue&type=script&lang=js"
export * from "./layouts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__